/** One sentence of help per card (v7 Part D pattern 20), in one registry. A card whose title is here shows a "?". */
export const CARD_HELP: Record<string, string> = {
  'The day\'s steps': 'What the ERP did by itself today and for tomorrow; a red step says why it failed and opens where to fix it.',
  'Quick actions': 'The things you do most, one click away.',
  'The business, last 7 days': 'Each figure is computed from the records; click one to see the rows behind it.',
  'The working day': 'Every timed step of the day. Click one to change its time; important ones need a second person.',
  'Steps': 'Each timed rule of the day, and what changes in the business when it changes.',
  'Jobs': 'Everything that runs by itself, when it last ran and what it did.',
  'Change history': 'Every change made in the Control Centre, who asked and who approved.',
  'What needs a second person': 'The actions that wait for another person\'s approval before they take effect.',
  'Reset test data': 'Brings test balances back to zero by new entries; nothing is deleted, and a second person approves.',
};

